export default "__VITE_ASSET__b185cafc__"